import { logger as r } from "../../shared-lib/index.js";
import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import T from "../managers/subscription-manager.js";
import { randomInclusive as U } from "../util/math.js";
import C from "../util/net.js";
import {
  newFeatureFlagFromJson as st,
  newFeatureFlagFromSerializedValue as it,
} from "./feature-flag-factory.js";
import D from "../util/request-header-utils.js";
export default class er extends y {
  constructor(t, s, i, r) {
    super(),
      (this.qt = t),
      (this.$t = s),
      (this.u = i),
      (this.oi = r),
      (this.ai = []),
      (this.ni = 0),
      (this.qt = t),
      (this.$t = s),
      (this.u = i),
      (this.oi = r),
      (this.li = null),
      (this.ui = new T()),
      (this.fi = 10),
      (this.ci = null),
      (this.di = null),
      e.Ht(this.ui);
  }
  Ss(t) {
    var s;
    if (
      (null === (s = this.qt) || void 0 === s ? void 0 : s.mi()) &&
      null != t &&
      t.feature_flags
    ) {
      this.ai = [];
      for (const s of t.feature_flags) {
        const t = st(s);
        t && this.ai.push(t);
      }
      (this.ni = new Date().getTime()), this.gi(), this.ui.Rt(this.ai);
    }
  }
  Fi() {
    let t = {};
    this.u && (t = this.u.j(o.C.vi));
    const s = {};
    for (const i in t) {
      const e = it(t[i]);
      e && (s[e.id] = e);
    }
    return s;
  }
  pi() {
    var t;
    return (null === (t = this.u) || void 0 === t ? void 0 : t.j(o.C.wi)) || {};
  }
  ji(t) {
    this.u && this.u.I(o.C.wi, t);
  }
  si(t) {
    return this.ui.Nt(t);
  }
  refreshFeatureFlags(t, s, i = !1, e = !0) {
    const r = () => {
      "function" == typeof s && s(), this.ui.Rt(this.ai);
    };
    if (!this.yi(i))
      return (
        !this.li &&
          this.qt &&
          (this.li = this.qt.bi(() => {
            this.refreshFeatureFlags(t, s);
          })),
        void r()
      );
    const h = this.$t;
    if (!h) return void r();
    e && this.Ci();
    const o = h.$s({}, !0),
      a = h.Ps(o, D._s.Ri);
    let n = !1;
    h.Gs(
      o,
      (h = -1) => {
        if (!this.$t) return void r();
        const l = new Date().valueOf();
        D.Hs(this.u, D._s.Ri, l),
          -1 !== h && a.push(["X-Braze-Req-Tokens-Remaining", h.toString()]),
          C.Ks({
            url: `${this.$t.Os()}/feature_flags/sync`,
            headers: a,
            data: o,
            L: (s) => {
              if (!this.$t.Qs(o, s, a)) return (n = !0), void r();
              this.$t.Vs(),
                this.Ss(s),
                (n = !1),
                D.Ws(this.u, D._s.Ri, 1),
                "function" == typeof t && t();
            },
            error: (t) => {
              this.$t.Ys(t, "retrieving feature flags"), (n = !0), r();
            },
            Zs: () => {
              if (e && n && !this.di) {
                D.ti(this.u, D._s.Ri);
                let e = this.ci;
                (null == e || e < 1e3 * this.fi) && (e = 1e3 * this.fi),
                  this.Ti(Math.min(3e5, U(1e3 * this.fi, 3 * e)), t, s, i);
              }
            },
          });
      },
      D._s.Ri,
      s,
    );
  }
  Ci() {
    null != this.di && (clearTimeout(this.di), (this.di = null));
  }
  Ti(t = 1e3 * this.fi, s, i, e = !1) {
    this.Ci(),
      (this.di = window.setTimeout(() => {
        this.refreshFeatureFlags(s, i, e);
      }, t)),
      (this.ci = t);
  }
  yi(t) {
    if (!this.qt) return !1;
    if (!t) {
      const t = this.qt.Di();
      if (null == t) return !1;
      let s = !1;
      if (!isNaN(t)) {
        if (-1 === t) return r.info("Feature flag refreshes not allowed"), !1;
        s = new Date().getTime() >= (this.ni || 0) + 1e3 * t;
      }
      if (!s)
        return (
          r.info(`Feature flag refreshes were rate limited to ${t} seconds`), !1
        );
    }
    return this.qt.mi();
  }
  Ii() {
    var t;
    return (
      (null === (t = this.u) || void 0 === t ? void 0 : t.j(o.C.Si)) || null
    );
  }
  qi() {
    var t, s;
    null === (t = this.u) ||
      void 0 === t ||
      t.I(o.C.Si, null === (s = this.oi) || void 0 === s ? void 0 : s.xi());
  }
  Ni() {
    var t;
    const s = null === (t = this.oi) || void 0 === t ? void 0 : t.xi(),
      i = this.Ii();
    return null == i || s === i;
  }
  gi() {
    if (!this.u) return;
    const t = {};
    for (const s of this.ai) {
      const i = s.Y();
      t[s.id] = i;
    }
    this.u.I(o.C.vi, t), this.u.I(o.C.zi, this.ni), this.qi();
  }
}
